const placeholders = {
  quill: {
    sk: 'Vložte poznámku ...',
    cz: 'Vložte poznámku ...',
    en: 'Insert note ...',
    de: 'Notiz einfügen'
  },
  geocoder: {
    sk: 'Vyhľadať',
    cz: 'Vyhledat',
    en: 'Search',
    de: 'Suche'
  }
}

export { placeholders }



//////////////////
// WEBPACK FOOTER
// ./static/localization/placeholders.js
// module id = 230
// module chunks = 1